var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"logos"},[_c('a',{attrs:{"href":"https://innohub13.de","target":"_blank","title":"Innovation Hub 13"}},[_c('img',{attrs:{"src":_vm.$config.graphpath + 'Logoleiste_InnovationHub13_Webseite.png',"alt":"","title":""}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }